import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const PsiForm = (props) => {
  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Format hours and minutes with leading zeros if necessary
    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  const [loading, setLoading] = useState(false);

  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const sampleRef = useRef({});
  const [sampleDetails, setSampleDetails] = useState([]);
  const [sampleClose, setSampleClose] = useState(false);

  const labelListRef = useRef({});
  const [labelListDetails, setLabelList] = useState([]);
  const [labelListClose, setLabelListClose] = useState(false);

  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);
  const { sendRequest: getLot } = useHttp();

  const [lotId, setLotId] = useState();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      stage: "Cleaning",
    };
    getLot(
      {
        url: "/api/getLotForPackQualityCheck/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        setLotId(data);
      }
    );
  }, [getLot]);

  const { sendRequest: postPsi } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    if (productDetails.length === 0) {
      toast.error("Product Details required");
      return;
    }
    if (sampleDetails === "") {
      toast.error("Sample check data required");
      return;
    }
    if (labelListDetails === "") {
      toast.error("Label check data required");
      return;
    }
    setLoading(true);

    const data = {
      psiDate: moment(frmRef.current.psi_date.value).format("DD/MM/YYYY"),
      supervisorEmployeeId: frmRef.current.emp_id.value,
      inspectionTime: frmRef.current.inspection_time.value,
      quantityVerifiedRecord: frmRef.current.quantity_verify.value,

      stockId: frmRef.current.lot_id.value,
      batchId: frmRef.current.batch_id.value,
      productDetails: productDetails,
      sampleCheck: sampleDetails,
      currentShelfLife: frmRef.current.shelf_life.value,
      temperature: frmRef.current.temp.value,
      lableCheckList: "labelListDetails",
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["psiId"] = props.update.psiId;
    }
    //console.log(data);
    postPsi(
      {
        url: "/api/preShipmentInspection/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Pre Shipment Inspection Data ${props.update ? "Updated" : "Added"}`
        );
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }

    );
  };
  useEffect(() => {
    //console.log(props.update);

    if (props.update) {
      // frmRef.current.psi_date.value = moment(props.update.psiDate).format(
      //   "YYYY-MM-DD"
      // );
      frmRef.current.emp_id.value = props.update.supervisorEmployeeId;
      frmRef.current.inspection_time.value = props.update.inspectionTime;
      frmRef.current.quantity_verify.value =
        props.update.quantityVerifiedRecord;
      frmRef.current.lot_id.value = props.update.stockId || 0;
      frmRef.current.batch_id.value = props.update.batchId || 0;
      setProductDetails(props.update.productDetails);
      setSampleDetails(props.update.sampleDetails);
      frmRef.current.shelf_life.value = props.update.currentShelfLife;
      frmRef.current.temp.value = props.update.temperature;
      setLabelList(props.update.labelListDetails);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);
  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
      },
    ]);

    //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitSampleList = (e) => {
    e.preventDefault();
    setSampleDetails((x) => [
      {
        cartonNumber: sampleRef.current.carton_number.value,
        labelWeight: sampleRef.current.label_weight.value,
        actualWeight: sampleRef.current.actual_weight.value,
        weightDifference: sampleRef.current.weight_difference.value,
        unit: sampleRef.current.unit.value,
        description: sampleRef.current.description.value,
        packagingCondition: sampleRef.current.packaging_condition.value,
        freshnessColour: sampleRef.current.freshness_colour.value,
        freshnessFlesh: sampleRef.current.freshness_flesh.value,
      },
    ]);
    setSampleClose(false);
    //console.log(sampleDetails);
  };
  const submitLabelList = (e) => {
    e.preventDefault();
    setLabelList((x) => [
      {
        labelId: labelListRef.current.label_id.value,
        packedItemId: labelListRef.current.packed_item_id.value,
        lotId: labelListRef.current.lot_id.value,
        batchId: labelListRef.current.batch_id.value,
        farmerId: labelListRef.current.farmer_id.value,
        netWeight: labelListRef.current.net_weight.value,
        grossWeight: labelListRef.current.gross_weight.value,
        unit: labelListRef.current.unit.value,
        pricePerUnit: labelListRef.current.price_per_unit.value,
        currency: labelListRef.current.currency.value,
        packingTimestamp: labelListRef.current.packing_timestamp.value,
        date: labelListRef.current.date.value,
        unitCode: labelListRef.current.unit_code.value,
        packhouseCode: labelListRef.current.packhouse_code.value,
        shelfLife: labelListRef.current.shelf_life.value,
        description: labelListRef.current.description.value,
      },
    ]);
    setLabelListClose(false);
    //console.log(labelListDetails);
  };

  const handleLotIdChange = (e) => {
    const id = e.target.value || 0;
    const filterData = lotId.filter((item) => item.stockId == id);
    //console.log(filterData);
    setProductDetails(filterData);
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "auto",
      height: "auto",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  return (
    <>
      {sampleClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Sample Check Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setSampleClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"carton_number"}>Carton Number</label>
              <input
                type={"input"}
                id={"carton_number"}
                required
                ref={(el) => (sampleRef.current["carton_number"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"label_weight"}>Weight at Label</label>
              <input
                type={"input"}
                id={"label_weight"}
                required
                ref={(el) => (sampleRef.current["label_weight"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"actual_weight"}>Weight at Actual</label>
              <input
                type={"input"}
                id={"actual_weight"}
                required
                ref={(el) => (sampleRef.current["actual_weight"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"weight_difference"}>difference in Weight</label>
              <input
                type={"input"}
                id={"weight_difference"}
                required
                ref={(el) => (sampleRef.current["weight_difference"] = el)}
                className="form-control"
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"actual_weight"}>Unit</label>
              <select
                id="unit"
                className="drop-prod form-control"
                ref={(el) => (sampleRef.current["unit"] = el)}
              >
                <option value="Number">Number</option>
                <option value="Miligram">Miligram</option>
                <option value="Gram">Gram</option>
                <option value="Kilogram">Kilogram</option>
                <option value="Milliliter">Milliliter</option>
                <option value="Liter">Liter</option>
                <option value="Tons">Tons</option>
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor={"description"}>Description</label>
              <input
                type={"input"}
                id={"description"}
                required
                ref={(el) => (sampleRef.current["description"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"packaging_condition"}>Packaging Condition</label>
              <select
                id="packaging_condition"
                className="drop-prod form-control"
                ref={(el) => (sampleRef.current["packaging_condition"] = el)}
              >
                <option value="Good">Good</option>
                <option value="Moderate">Moderate</option>
                <option value="Poor">Poor</option>
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor={"freshness_colour"}>Freshness Colour</label>
              <input
                type={"input"}
                id={"freshness_colour"}
                required
                ref={(el) => (sampleRef.current["freshness_colour"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"freshness_flesh"}>Freshness-Flesh</label>
              <select
                id="freshness_flesh"
                className="drop-prod form-control"
                ref={(el) => (sampleRef.current["freshness_flesh"] = el)}
              >
                <option value="Soft">Soft</option>
                <option value="Moderate">Moderate</option>
                <option value="Hard">Hard</option>
              </select>
            </div>
          </div>

          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={submitSampleList}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      {labelListClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Label List Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setLabelListClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"label_id"}>Label id</label>
              <input
                type={"input"}
                id={"label_id"}
                required
                ref={(el) => (labelListRef.current["label_id"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"packed_item_id"}>Packed item id</label>
              <input
                type={"input"}
                id={"packed_item_id"}
                required
                ref={(el) => (labelListRef.current["packed_item_id"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"lot_id"}>Lot id</label>
              <input
                type={"input"}
                id={"lot_id"}
                required
                ref={(el) => (labelListRef.current["lot_id"] = el)}
                className="form-control"
                //onChange={() => handleLotIdChange}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"batch_id"}>Batch id</label>
              <input
                type={"input"}
                id={"batch_id"}
                required
                ref={(el) => (labelListRef.current["batch_id"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"farmer_id"}>Farmer id</label>
              <input
                type={"input"}
                id={"farmer_id"}
                required
                ref={(el) => (labelListRef.current["farmer_id"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"net_weight"}>Net Weight</label>
              <input
                type={"input"}
                id={"net_weight"}
                required
                ref={(el) => (labelListRef.current["net_weight"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"gross_weight"}> Carton Gross Weight</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["gross_weight"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"unit"}>Unit</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["unit"] = el)}
                required
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"price_per_unit"}>Price Per Unit</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["price_per_unit"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"currency"}>Currency</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["currency"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"packing_timestamp"}>Packing Timestamp</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["packing_timestamp"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"date"}>Date </label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["date"] = el)}
                required
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor={"unit_code"}>Production Unit Code</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["unit_code"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"packhouse_code"}>PackingHouse Code</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["packhouse_code"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"shelf_life"}>Shelf life</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["shelf_life"] = el)}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"description"}>Description</label>
              <input
                type={"input"}
                className="form-control"
                ref={(el) => (labelListRef.current["description"] = el)}
                required
              />
            </div>
          </div>

          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={submitLabelList}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Item Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <table className="table table-sm table-bordered text-center">
            {" "}
            <thead>
              <tr className="">
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Item Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.productTypeName}</td>
                      <td>{itm.productSubTypeName}</td>
                      <td>{itm.productQuantityBal}</td>
                      <td>{itm.unitName}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <hr />
          <div className="text-center mt-2">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}

      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Pri Shipment Inspection Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <br />
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <label htmlFor={"dpi_date"}> {"DPI Date"}</label>
                      <input
                        type={"date"}
                        id={"psi_date"}
                        required
                        ref={(el) => (frmRef.current["psi_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        // value={selectedDate}
                        onChange={handleDateChange}
                        value={
                          props.update
                            ? props.update.psiDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assigned Supervisor"}</label>
                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              key={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspection_time"}>
                        {" "}
                        {"Inspection Time "}
                      </label>
                      <input
                        type={"time"}
                        id={"inspection_time"}
                        required
                        ref={(el) => (frmRef.current["inspection_time"] = el)}
                        defaultValue={getCurrentTime()}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"quantity_verify"}>
                        {"Quantity verified as on record"}
                      </label>
                      <select
                        id="quantity_verify"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["quantity_verify"] = el)}
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}> {"Lot id "}</label>
                      <select
                        id="lot_id"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        required
                        onChange={handleLotIdChange}
                      >
                        <option value="">Select</option>
                        {lotId &&
                          lotId.map((x) => (
                            <option
                              value={x.stockId}
                              key={x.stockId}
                              selected={
                                props.update &&
                                props.update.stockId == x.stockId
                              }
                            >
                              {x.lotNo + "(" + x.productName + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"batch_id"}> {"Batch id"}</label>
                      <input
                        type={"input"}
                        id={"batch_id"}
                        required
                        ref={(el) => (frmRef.current["batch_id"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          // setProductDetails((items) => items.filter((x) => x.isSave));
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sample_check"}> {"Sample Check"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"sample_check"}
                        ref={(el) => (frmRef.current["sample_check"] = el)}
                        className="btn btn-sm btn-warning"
                        autoComplete="off"
                        onClick={() => {
                          setSampleClose(true);
                        }}
                      >
                        Check
                      </button>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-3">
                      <label htmlFor={"shelf_life"}>
                        {" "}
                        {"Current Shelf Life (days) "}
                      </label>
                      <input
                        type={"number"}
                        id={"shelf_life"}
                        required
                        ref={(el) => (frmRef.current["shelf_life"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"temp"}> {"Temperature (°C) "}</label>
                      <input
                        type={"number"}
                        id={"temp"}
                        required
                        ref={(el) => (frmRef.current["temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"label_check_list"}>
                        {" "}
                        {"Label Check List"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"label_check_list"}
                        ref={(el) => (frmRef.current["label_check_list"] = el)}
                        className="btn btn-sm btn-info"
                        autoComplete="off"
                        onClick={() => {
                          setLabelListClose(true);
                        }}
                      >
                        Check
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="text-right mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PsiForm;
